export const LoadingScreen = ({ label = 'Loading…' }) => (
  <div className="min-h-screen flex items-center justify-center bg-ink" data-testid="loading-screen">
    <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-slate-400">
      <span className="w-2.5 h-2.5 bg-cyan blink" />
      {label}
    </div>
  </div>
);
